
import React from "react";
import { CardTitle } from "@/components/ui/card";

interface FormHeaderProps {
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;
  isSaving: boolean;
}

export const FormHeader: React.FC<FormHeaderProps> = ({
  isEditing,
  setIsEditing,
  isSaving
}) => {
  return (
    <div className="flex flex-row items-center justify-between pb-2">
      <CardTitle>Formulaires</CardTitle>
    </div>
  );
};
